// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + (chunkId === 347 ? "secondary" : chunkId) + "." + {"347":"4f2c6ce40c8f7d70ce76","724":"9a3a7646c83fcdbf7bd4"}[chunkId] + ".js";
};